import buttonLoader from '../../../../components/button';
import Api from '@/utils/api';

export default {
  components: { buttonLoader },
  data () {
    return {
      active: {
        field1: false,
        field2: false,
        field3: false,
        field4: false,
      },
      formatData: null,
    };
  },
  methods: {
    selectOpt (ev) {
      this.formatData[ev.target.id] = ev.target.value;
    },
    updateOption () {
      Api.settings.formattingConfiguration
        .update(this.formatData)
        .then((data) => {
          if (data.data.status) {
            this.$store.dispatch('SET_DATE_FORMAT', this.formatData);

            this.$root.$emit('notification', {
              message: data.data.message,
              type: 'info',
              show: true,
            });
          } else {
            this.$root.$emit('notification', {
              message: data.data.message,
              type: 'error',
              show: true,
            });
          }
        });
    },
  },
  mounted () {
    this.formatData = this.$store.getters.user.UserFormaterData;
  },
};
